import { action } from '@ember/object';
import type Owner from '@ember/owner';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

import type { PopupData, Service } from 'webapp-types';

import CommonUiIconComponent from 'webapp/components/common/ui-icon';
import FormSelectComponent from 'webapp/components/form/select';
import PopupInnerModalComponent from 'webapp/components/popup/inner/modal';
import type { Args } from 'webapp/components/popup/inner/modal';
import SubmitButtonComponent from 'webapp/components/submit-button';

// Lists the client spaces Home can add and hands the pick back.
export default class HomePopupPickClientComponent extends PopupInnerModalComponent<PopupData.Home.PickClient> {
	@service('model-manager/spaces') declare mmSpacesService: Service.ModelManager.Spaces;

	@tracked selectedClient = '';

	readonly clients: LabelValuePairString[];

	constructor(owner: Owner, args: Args) {
		super(owner, args);

		// color draws the select's circle swatch.
		this.clients = this.mmSpacesService.clientModelsToPick.map((space) => ({
			value: space.id!,
			label: space.companyName,
			color: space.color,
		}));
	}

	get isSubmitDisabled(): boolean {
		return !this.selectedClient;
	}

	@action
	changeClient(newClientId: string): void {
		this.selectedClient = newClientId;
	}

	@action
	save(): void {
		if (!this.selectedClient) {
			return;
		}

		this.popupData.onSubmit(Number(this.selectedClient));
		this.close();
	}

	<template>
		<div class="title">
			<CommonUiIconComponent @name="Clients" @size="lg" />Select client
		</div>

		<div class="content">
			<h4>Select a client you would like to add to Home:</h4>
			<div class="row">
				<FormSelectComponent
					name="client"
					@placeholder="Select client"
					@selected={{this.selectedClient}}
					@options={{this.clients}}
					@isNumeric={{false}}
					@onChange={{this.changeClient}}
					@maxOptionsShown={{this.clients.length}}
					@extraClass="client-select"
				/>
			</div>

			<div class="controls2">
				<SubmitButtonComponent
					@text="Cancel"
					@theme="grey-empty"
					@noDelay={{true}}
					@onTrigger={{this.close}}
				/>
				<SubmitButtonComponent
					@text="Add to Home"
					@extraClass="save"
					@onTrigger={{this.save}}
					@isDisabled={{this.isSubmitDisabled}}
				/>
			</div>
		</div>
	</template>
}
